module.exports = __webpack_public_path__ + "img/fb875342a401c37419232dfcc75492ca.png";